import { HeaderGroup } from '@tanstack/react-table';
import React from 'react';

import { ColumnAdditionalData, ICssClasses } from '../../types';

import { FooterCellV8 } from './components/footer-cell/FooterCellV8';
import { FooterRow } from './components/footer-row/FooterRow';
import { FooterWrapperV8 } from './components/footer-wrapper/FooterWrapperV8';

interface TableFooterV8Props {
  headerGroups: HeaderGroup<ColumnAdditionalData>[];
  classes?: ICssClasses;
  grouping: string[];
  cellProps?: Record<string, number>;
}

export function TableFooterV8(props: TableFooterV8Props) {
  return (
    <FooterWrapperV8 className={props.classes?.footerWrapper}>
      {props.headerGroups.map((group) => {
        return (
          <FooterRow
            className={props.classes?.footerRow}
            groupLevel={props.grouping?.length}
            key={group.id}
          >
            {group.headers.map((header) => {
              return (
                <FooterCellV8
                  key={header.id}
                  header={header}
                  classes={props.classes}
                  contentCellProps={props.cellProps}
                />
              );
            })}
          </FooterRow>
        );
      })}
    </FooterWrapperV8>
  );
}
